import React, {useEffect, useMemo, useState} from 'react';
import {Input, message, Modal} from 'antd';
import './index.scss';

interface NameModalProps {
  open: boolean;
  title: string;
  placeholder?: string;
  initialValue?: string;
  // maxLength?: number;
  onOk: (name: string) => Promise<void>;
  onCancel: () => void;
}

export function NameModal({
                            open,
                            title,
                            placeholder = '请输入名称',
                            initialValue = '',
                            // maxLength = 50,
                            onOk,
                            onCancel
                          }: NameModalProps) {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) setName(initialValue);
  }, [open, initialValue]);

  const trimmedName = useMemo(() => {
    return name.trim();
  }, [name]);

  const disabled = !trimmedName || loading;

  async function handleOk() {
    const value = trimmedName;

    if (!value) {
      void message.warning('请输入名称');
      return;
    }

    setLoading(true);

    try {
      await onOk(value);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal
      className="drive-name-modal"
      title={title}
      visible={open}
      confirmLoading={loading}
      okText="确认"
      cancelText="取消"
      okButtonProps={{disabled}}
      onOk={handleOk}
      onCancel={onCancel}
      destroyOnClose
    >
      <div className="drive-name-modal__content">
        <Input
          size="large"
          placeholder={placeholder}
          value={name}
          // maxLength={maxLength}
          onChange={(e) => setName(e.target.value)}
          onPressEnter={() => {
            if (!disabled) {
              void handleOk();
            }
          }}
          autoFocus
        />

        {/*<div className="drive-name-modal__footer">*/}
        {/*  <span className="drive-name-modal__tip">*/}
        {/*    支持中文、英文、数字*/}
        {/*  </span>*/}

        {/*  <span className="drive-name-modal__count">*/}
        {/*    {name.length}/{maxLength}*/}
        {/*  </span>*/}
        {/*</div>*/}
      </div>
    </Modal>
  );
}
